module.exports = __webpack_public_path__ + "media/images/mr2-1d1d5bd1304d15520be03f202c91087e.jpg";